import React, { useState, useEffect } from "react";
import * as style from "./style.mod.scss";
import { getMergedReviewsForCluster } from "../../data/trusted-reviews";
import { StarFill } from "react-bootstrap-icons";
import locale from "locales";

const ProductReviewsSnippet = ({ variants }) => {
  const [averageRating, setAverageRating] = useState(null);
  const [totalReviews, setTotalReviews] = useState(0);

  useEffect(() => {
    if (!variants || !Array.isArray(variants)) {
      return;
    }
    const fetchReviews = async () => {
      try {
        const reviews = await getMergedReviewsForCluster(variants);

        if (Array.isArray(reviews) && reviews.length > 0) {
          const clusters = variants.map(variant => variant?.store?.sku);
          const filteredReviews = reviews.filter(review =>
            review.cluster && clusters.includes(review.product.sku)
          );

          if (filteredReviews.length > 0) {
            const totalScore = filteredReviews.reduce((sum, review) => sum + (review.rating || 0), 0);
            setTotalReviews(filteredReviews.length);
            setAverageRating(totalScore / filteredReviews.length);
          }
        }
      } catch (error) {
        console.error("Error fetching reviews:", error);
      }
    };

    fetchReviews();
  }, [variants]);

  const round = (avg) => avg && Math.round(avg);
  const prec = (avg) => avg && Number.parseFloat(avg).toPrecision(2);


  return (
    <div className={style.productStars}>
      {
        averageRating &&
        Array(round(averageRating)).fill().map(() => (
          <div key={Math.random()} className={style.clipStar}><StarFill /></div>
        ))
      }
      {
        averageRating &&
        <span className={style.ratingText}>{prec(averageRating)} ({totalReviews} {locale.pages.reviews.reviews})</span>
      }
    </div>
  );
};
export default ProductReviewsSnippet;